
import { Howler, Howl } from "howler";

const noteToInteger = {
  "C1": 0,
  "Dbb1": 0,

  "C#1": 1,
  "Db1": 1,
  
  "D1": 2,
  "C##1": 2,
  "Ebb1": 2,

  "D#1": 3,
  "Eb1": 3,

  "E1": 4,
  "Fb1": 4, // ***
  "Fbb1": 3, // NEW
  "D##1": 4,
  
  "E#1": 5, // ***
  "F1": 5,
  "Gbb1": 5,

  "F#1": 6,
  "Gb1": 6,

  "G1": 7,
  "F##1": 7,
  "Abb1": 7,

  "G#1": 8,
  "Ab1": 8,

  "A1": 9,
  "G##1": 9,
  "Bbb1": 9,

  "A#1": 10,
  "Bb1": 10,
  
  "B1": 11,
  "A##1": 11,

  "B#1": 12, // ***
  "Cb2": 11, // ***
  "Cbb2": 10, // NEW

  "C2": 12,
  "Dbb2": 12,

  "C#2": 13,
  "Db2": 13,

  "D2": 14,
  "C##2": 14,
  "Ebb2": 14,

  "D#2": 15,
  "Eb2": 15,

  "E2": 16,
  "D##2": 16,

  "Fb2": 16, // **
  "Fbb2": 15, // NEW
  "E#2": 17, // **

  "F2": 17,
  "Gbb2": 17,

  "F#2": 18,
  "Gb2": 18,

  "G2": 19,
  "F##2": 19,
  "Abb2": 19,

  "G#2": 20,
  "Ab2": 20,

  "A2": 21,
  "G##2": 21,
  "Bbb2": 21,

  "A#2": 22,
  "Bb2": 22,

  "B2": 23,
  "A##2": 23,

  "B#2": 24, // **
  "Cb3": 23, // **
  "Cbb3": 22, // NEW

  "C3": 24,
  "Dbb3": 24,

  "C#3": 25,
  "Db3": 25,

  "D3": 26,
  "C##3": 26,
  "Ebb3": 26,

  "D#3": 27,
  "Eb3": 27,

  "E3": 28,
  "D##3": 28,

  "Fb3": 28, // **
  "Fbb3": 27, // NEW
  "E#3": 29, // **

  "F3": 29,
  "Gbb3": 29,

  "F#3": 30,
  "Gb3": 30,
  
  "G3": 31,
  "F##3": 31,
  "Abb3": 31,

  "G#3": 32,
  "Ab3": 32,

  "A3": 33,
  "G##3": 33,
  "Bbb3": 33,

  "A#3": 34,
  "Bb3": 34,

  "B3": 35,
  "A##3": 35,

  "B#3": 36, // **
  "Cb4": 35, // **
  "Cbb4": 34, // NEW

  "C4": 36,
  "Dbb4": 36,


  "C#4": 37,
  "Db4": 37,

  "D4": 38,
  "C##4": 38,
  "Ebb4": 38,

  "D#4": 39,
  "Eb4": 39,

  "E4": 40,
  "D##4": 40,
  "Fb4": 40, // **
  "Fbb4": 39, // NEW
  "E#4": 41, // **

  "F4": 41,
  "Gbb4": 41,

  "F#4": 42,
  "Gb4": 42,

  "G4": 43,
  "F##4": 43,
  "Abb4": 43,

  "G#4": 44,
  "Ab4": 44,

  "A4": 45,
  "G##4": 45,
  "Bbb4": 45,

  "A#4": 46,
  "Bb4": 46,

  "B4": 47,
  "A##4": 47,

  "B#4": 48, // **
  "Cb5": 47, // **
  "Cbb5": 46, // NEW

  "C5": 48,
  "Dbb5": 48,

  "C#5": 49,
  "Db5": 49,

  "D5": 50,
  "C##5": 50,
  "Ebb5": 50,

  "D#5": 51,
  "Eb5": 51,

  "E5": 52,
  "D##5": 52,

  "Fb5": 52, // **
  "Fbb5": 51, // NEW
  "E#5": 53, // **

  "F5": 53,
  "Gbb5": 53,

  "F#5": 54,
  "Gb5": 54,

  "G5": 55,
  "F##5": 55,
  "Abb5": 55,

  "G#5": 56,
  "Ab5": 56,

  "A5": 57,
  "G##5": 57,
  "Bbb5": 57,

  "A#5": 58,
  "Bb5": 58,

  "B5": 59,
  "A##5": 49,

  "B#5": 60, // **
  "Cb6": 59, // **
  "Cbb6": 58, // NEW

  "C6": 60,
  "Dbb6": 60,

  "C#6": 61,
  "Db6": 61,

  "D6": 62,
  "C##6": 62,
  "Ebb6": 62,

  "D#6": 63,
  "Eb6": 63,

  "E6": 64,
  "D##6": 64,

  "Fb6": 64, // **
  "Fbb6": 63, // NEW
  "E#6": 65, // **

  "F6": 65,
  "Gbb6": 65,

  "F#6": 66,
  "Gb6": 66,

  "G6": 67,
  "F##6": 67,
  "Abb6": 67,

  "G#6": 68,
  "Ab6": 68,

  "A6": 69,
  "G##6": 69,
  "Bbb6": 69,

  "A#6": 70,
  "Bb6": 70,
  
  "B6": 71,
  "A##6": 71,

  "B#6": 72, // **
  "Cb7": 71, // **
  "Cbb7": 70, // NEW
  "C7": 72,
  "Dbb7": 72
};
const integerToNote = {
  0: ["C1"],
  1: ["C#1", "Db1"],
  2: ["D1"],
  3: ["D#1", "Eb1"],
  4: ["E1"],
  5: ["F1"],
  6: ["F#1", "Gb1"],
  7: ["G1"],
  8: ["G#1", "Ab1"],
  9: ["A1"],
  10: ["A#1", "Bb1"],
  11: ["B1"],

  12: ["C2"],
  13: ["C#2", "Db2"],
  14: ["D2"],
  15: ["D#2", "Eb2"],
  16: ["E2"],
  17: ["F2"],
  18: ["F#2", "Gb2"],
  19: ["G2"],
  20: ["G#2", "Ab2"],
  21: ["A2"],
  22: ["A#2", "Bb2"],
  23: ["B2"],

  24: ["C3"],
  25: ["C#3", "Db3"],
  26: ["D3"],
  27: ["D#3", "Eb3"],
  28: ["E3"],
  29: ["F3"],
  30: ["F#3", "Gb3"],
  31: ["G3"],
  32: ["G#3", "Ab3"],
  33: ["A3"],
  34: ["A#3", "Bb3"],
  35: ["B3"],

  36: ["C4"],
  37: ["C#4", "Db4"],
  38: ["D4"],
  39: ["D#4", "Eb4"],
  40: ["E4"],
  41: ["F4"],
  42: ["F#4", "Gb4"],
  43: ["G4"],
  44: ["G#4", "Ab4"],
  45: ["A4"],
  46: ["A#4", "Bb4"],
  47: ["B4"],

  48: ["C5"],
  49: ["C#5", "Db5"],
  50: ["D5"],
  51: ["D#5", "Eb5"],
  52: ["E5"],
  53: ["F5"],
  54: ["F#5", "Gb5"],
  55: ["G5"],
  56: ["G#5", "Ab5"],
  57: ["A5"],
  58: ["A#5", "Bb5"],
  59: ["B5"],

  60: ["C6"],
  61: ["C#6", "Db6"],
  62: ["D6"],
  63: ["D#6", "Eb6"],
  64: ["E6"],
  65: ["F6"],
  66: ["F#6", "Gb6"],
  67: ["G6"],
  68: ["G#6", "Ab6"],
  69: ["A6"],
  70: ["A#6", "Bb6"],
  71: ["B6"],
  72: ["C7"]
};
const numberOfInstrumentNotes = 72;

var sound = new Howl({
  
  src: ["instruments/pianosprite.webm", "instruments/pianosprite.mp3"],
  onload: () => {
    soundEngine.init();
    console.log("Sound file loaded");
  },
  onloaderror: (e, msg) => {
    console.log("Sound file could not be loaded!", e, msg);
  }
});

var correctAnswer = new Howl({
  src: ['instruments/correct-answer.webm', 'instruments/correct-answer.mp3']
});

var wrongAnswer = new Howl({
  src: ['instruments/wrong-answer.webm', 'instruments/wrong-answer.mp3']
});

var levelAwardGold = new Howl({
  src: ['instruments/level-award-gold.webm', 'instruments/level-award-gold.mp3']
});

var levelAwardSilver = new Howl({
  src: ['instruments/level-award-silver.webm', 'instruments/level-award-silver.mp3']
});

var levelAwardBronze = new Howl({
  src: ['instruments/level-award-bronze.webm', 'instruments/level-award-bronze.mp3']
});

var utils = {
  accurateInterval: function(func, interval, opts) {
    if (!opts) opts = {};
    var clear, nextAt, timeout, wrapper, now;
    now = new Date().getTime();
    nextAt = now;
    if (opts.aligned) {
      nextAt += interval - (now % interval);
    }
    if (!opts.immediate) {
      nextAt += interval;
    }
    timeout = null;
    wrapper = function wrapper() {
      var scheduledTime = nextAt;
      nextAt += interval;
      timeout = setTimeout(wrapper, nextAt - new Date().getTime());
      func(scheduledTime);
    };
    clear = function clear() {
      return clearTimeout(timeout);
    };
    timeout = setTimeout(wrapper, nextAt - new Date().getTime());
    return {
      clear: clear
    };
  },

  timer: function(times, timeInterval, callback) {
    var i = 0;
    var interval = this.accurateInterval(
      function() {
        callback(i);
        i++;
        if (i >= times) {
          interval.clear(); // stop it
        }
      },
      timeInterval,
      {
        immediate: true
      }
    );
  }
};

var soundEngine = {
  init: function() {
    // cut up sound sprite in chuncks every 2400 miliseconds
    var timeIndex = 0;
    var lengthOfNote = 2400;
    for (var i = 0; i < numberOfInstrumentNotes + 1; i++) {
      sound["_sprite"]["piano" + i] = [timeIndex, lengthOfNote];
      timeIndex += 2400;
    }
  },
  play: function(soundSequenceData, timeInterval, volume) {
    // {
    //   soundSequence: ['C3', 'E3', 'G3'], // Array. The collection of sound sequence notes as strings
    //   harmony: 'ascending' // String. Takes ascending, descending or harmonic
    //   timeInterval: 300 // Integer. time between notes in miliseconds when harmony is ascending or descending
    // }
    
    // set sound volume
    sound.volume(volume / 100);


    var soundSequenceConverted = this.convertNotesToIntegers(soundSequenceData.soundSequence);
    var soundSequenceLength = soundSequenceData.soundSequence.length;
    if (soundSequenceData.harmony === "ascending") {
      // Play sound sequence ascending
      utils.timer(
        soundSequenceLength,
        timeInterval,
        times => {
          sound.play(`piano${soundSequenceConverted[times]}`);
        },
        () => {
          // Timer finished (re add event listeners etc..)
          // Could set global flag to true here, and only take argument if flag is true / else return
        }
      );
    } else if (soundSequenceData.harmony === "descending") {
      // Reverse sound sequence
      var soundSequenceConvertedAndReversed = soundSequenceConverted
        .slice()
        .reverse();
      //  Play sound sequence descending
      utils.timer(
        soundSequenceLength,
        timeInterval,
        times => {
          sound.play(`piano${soundSequenceConvertedAndReversed[times]}`);
        },
        () => {
          // Timer finished
        }
      );
    } else if (soundSequenceData.harmony === "harmonic") {
      // lower volume of sound
      // sound.volume(0.75);
      // Play sound sequence in harmony
      utils.timer(
        soundSequenceLength,
        0,
        times => {
          sound.play(`piano${soundSequenceConverted[times]}`);
        },
        () => {
          // Timer finished
        }
      );
    } else {
      return;
    }
  },
  stop: function() {
    sound.stop();
  },
  invertChord: function(soundSequence, inversionDegree) {
    // Check if inversion is legal;
    // - all notes are within one octave
    // - is not augmented
    // **** Validation ****
    // If sound sequence longer than 4 notes, throw error
    if (soundSequence.length > 4) {
      throw 'Error: Chord is too long to be properly inverted';
    }
    // Check if sound sequence span exceeds one octave.
    let chordAsIntegers = this.convertNotesToIntegers(soundSequence);
    let lowestNoteNumber = Math.min(...chordAsIntegers);
    let highestNoteNumber = Math.max(...chordAsIntegers);
 
    if (highestNoteNumber - lowestNoteNumber > 11) {
      throw 'Error: Chord exceeds an octave and can therefore not be inverted';
    }

    let maxInversions = soundSequence.length - inversionDegree;
    // If no inversion requested (0), return the original sound sequence
    if (inversionDegree === 0) {
      return soundSequence;
    }
    // For each inversion degree. take note from chord, octavice it and put it on the end of the sound sequence array. 
    // Remove the first item (the original before octavized)
    if (inversionDegree > 0 && maxInversions >= 1) {
      for (let i = 0; i < inversionDegree; i++) {
        let fullNoteName = soundSequence[0];
        let noteOctaveNumber = fullNoteName[fullNoteName.length - 1];
        let noteName = fullNoteName.slice(0, -1);
        let octavizedNoteName = noteName + (parseInt(noteOctaveNumber) + 1);
        soundSequence.push(octavizedNoteName);
        soundSequence.shift();
      }
      return soundSequence;
    } else {
      throw 'Error: inversion degree exceeds sound sequence limit. (it does not have that many inversions)';
    }

},
  convertNotesToIntegers: function(noteInput) {
    var noteNumbers = [];
    // Return array of note numbers if input is array
    if (Array.isArray(noteInput)) {
      noteInput.forEach(noteName => {
        if (noteName in noteToInteger) {
          noteNumbers.push(noteToInteger[noteName]);
        }
      });
      return noteNumbers;
    }
    if (typeof noteInput === "string") {
      return noteToInteger[noteInput];
    }
  },
  integerToNote: function(int) {
    if (integerToNote[int].length === 2) {
      var array = integerToNote[int];
      var zeroOrOne = Math.round(Math.random());

      return array[zeroOrOne];
    } else if (integerToNote[int].length === 1) {
      return integerToNote[int][0];
    }
  },
  getRandomStartNote: function(largestIntervalSpan, toneRange) {
    // Set the piano tone range (the range the random notes should be generated within)
    toneRange = this.convertNotesToIntegers(toneRange);

    // Find the span the sound sequence can be played within
    let maxStartNote = toneRange[1] - largestIntervalSpan - 2;
    let minStartNote = minStartNote = toneRange[0];
    let randomStartingNote = Math.floor(
      Math.random() * (maxStartNote - minStartNote + 1) + minStartNote
    );

    return this.integerToNote(randomStartingNote);
  },
  playCorrectSound: function(vol) {
    correctAnswer.volume(vol / 100);
    correctAnswer.play();
  },
  playWrongSound: function(vol) {
    wrongAnswer.volume(vol / 100);
    wrongAnswer.play();
  },
  playExerciseCompletedGold: function(vol) {
    levelAwardGold.volume(vol / 100);
    levelAwardGold.play();
  },
  playExerciseCompletedSilver: function(vol) {
    levelAwardSilver.volume(vol / 100);
    levelAwardSilver.play();
  },
  playExerciseCompletedBronze: function(vol) {
    levelAwardBronze.volume(vol / 100);
    levelAwardBronze.play();
  }
};


export {soundEngine, utils}